import React, { memo, useEffect, useRef, useState } from 'react';

import { createPortal } from 'react-dom';

export interface IPortal {
  id: string;
  children: React.ReactNode;
}

const Portal = ({ id, children }: IPortal) => {
  const el = useRef(document.getElementById(id) || document.createElement('div'));
  const [dynamic] = useState(!el.current.parentElement);

  useEffect(() => {
    const element = el.current;
    if (dynamic) {
      element.id = id;
      document.body.appendChild(element);
    }
    return () => {
      if (dynamic && element.parentElement) {
        element.parentElement.removeChild(element);
      }
    };
  }, [dynamic, id]);

  return createPortal(children, el.current);
};

export default memo(Portal);
